export { default as MaterialsBrandsFilterBadge } from './MaterialsBrandsFilterBadge';
